import { alertWithSuccessMessage } from "components/modal/success_modal";
import { CenterProps } from "lib/all_type/center_props";
import commentrequest from "lib/worker/api/comment";
import { useEffect, useState } from "react";
import LayoutMaster from "../components/layout/layout_master";
import { MaxButton } from "../components/view/button";
import TimerComment from "components/view/timer_comment";
import get_comment_time, {
  GetCommentTimeResponse,
} from "lib/worker/api/get_comment_time";
import { AppReducerStateProps } from "lib/store";
import { connect } from "react-redux";
import { GetServerSideProps } from "next";
import {
  CheckWithPrefix,
  CheckWithPrefixResponse,
} from "lib/infomation_vender/document";

interface WriteCommentProps extends CenterProps {
  state: AppReducerStateProps;
  infomation: CheckWithPrefixResponse;
}

function WriteComment(props: WriteCommentProps) {
  const [comment, setComment] = useState<string>("");
  const [commentTime, setCommentTime] = useState<GetCommentTimeResponse[]>();

  const commentRequest = () => {
    const isLogin = props.state.member.isLogin;

    if (!isLogin) {
      props.alertWithMessage("กรุณาเข้าสู่ระบบก่อนคอมเม้น");
      return;
    }

    commentrequest({ text: comment })
      .then(() => {
        alertWithSuccessMessage("คอมเม้นสำเร็จ");
      })
      .catch((error) => {
        props.alertWithMessage(error.response.data.message);
      });
  };

  useEffect(() => {
    get_comment_time()
      .then((json) => {
        setCommentTime(json);
      })
      .catch((_error) => {});
  }, []);

  return (
    <LayoutMaster
      content_setting={{
        title: "กิจกรรมคอมเม้นเว็บไซต์",
        description: "ว็บคาสิโนออนไลน์แห่งปี กิจกรรมมากมาย",
      }}
      information={props.infomation}
    >
      <div>
        <h1 className="text-center margin-top-20" style={{ paddingTop: 20 }}>
          <div className="btn text-left">
            <div className="btn-group">
              <div className="bg-comment">
                <h1
                  style={{
                    float: "left",
                    marginTop: 2,
                  }}
                >
                  กิจกรรมคอมเม้นเว็บไซต์
                </h1>
              </div>
            </div>
          </div>
        </h1>
        <h2 className="text-center">
          เมื่อท่านเขียนรีวิว ท่านจะได้รับ 300 uDiamond ไปแบบฟรีๆ วันละครั้ง
        </h2>
        <div className="container">
          <div className="bg-blue border-radius" style={{ padding: 15 }}>
            <h4 style={{ paddingTop: 20 }}>
              <span>กล่องเขียนรีวิว </span>
            </h4>
            <textarea
              className="form-control margin-top-10 margin-bottom-10"
              id="exampleFormControlTextarea1"
              value={comment}
              onChange={(value) => {
                setComment(value.target.value);
              }}
            ></textarea>
            <div>{comment.length}/300</div>
            <div>
              <MaxButton
                title="รีวิว (รับเลย 300 uDiamond)"
                className="text-center col-8 col-md-4 col-lg-3 bg-invite button-glowing center-row-content"
                onClick={commentRequest}
              ></MaxButton>
            </div>
            {(commentTime ?? []).length != 0 && (
              <div
                style={{ paddingBottom: 10, marginTop: 6 }}
                className="row center-row-content"
              >
                <TimerComment></TimerComment>
              </div>
            )}
          </div>
        </div>
      </div>
    </LayoutMaster>
  );
}

export const getServerSideProps: GetServerSideProps<any> = async (context) => {
  const { req } = context;
  console.log("COTEXT =>", req.headers.host);
  console.log("query =>", context.query);
  const infomation = CheckWithPrefix({ host: req.headers.host as string });

  return {
    props: {
      isLogin: context.req.cookies.access_token != undefined,
      infomation: infomation,
    },
  };
};

const mapStateToProps = (state: AppReducerStateProps) => {
  return {
    state: state,
  };
};

export default connect(mapStateToProps)(WriteComment);
